module.exports = __webpack_public_path__ + "static/media/br_border2.6a22c9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/share/img/br_border2.png
// module id = 1527
// module chunks = 0